import React, { useState, useEffect, useMemo } from "react";
import { SelectButton } from "primereact/selectbutton";
import { useDispatch } from "react-redux";
import { setAreaType } from "../../../Store/Dashboard/DashboardActions";
import "./SelectButtonStyle.scss";
import { useTranslation } from "react-i18next";

const SelectButtons = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  
  const data = useMemo(() => [t("Urban"), t("Rural")], [t]);

  const areaId = parseInt(sessionStorage.getItem("areaId"), 10) || 1;
  const accessMenus = sessionStorage.getItem("accessMenus");
  const jsonAccessMenus = accessMenus ? JSON.parse(accessMenus) : [];

  const menu = jsonAccessMenus?.find((menu) => menu.menuName === "dashboard");
  const hasRuralAccess = menu?.features?.rural?.hasAccess ?? false;
  const hasUrbanAccess = menu?.features?.urban?.hasAccess ?? false;

  const initialIndex = areaId === 1 ? 0 : 1;
  const [value, setValue] = useState(data[initialIndex]);
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    if (data.length === 0) return;

    if (hasRuralAccess && hasUrbanAccess) {
      setValue(data[0]);
      setIsDisabled(false);
    } else if (!hasRuralAccess && hasUrbanAccess) {
      setValue(data[0]);
      setIsDisabled(true);
    } else if (hasRuralAccess && !hasUrbanAccess) {
      setValue(data[1]);
      setIsDisabled(true);
    }
  }, [hasRuralAccess, hasUrbanAccess, data]);

  useEffect(() => {
    if (data.length === 0) return;
    const index = areaId === 1 ? 0 : 1;
    setValue(data[index]);
    sessionStorage.setItem('areaId', areaId);
    dispatch(setAreaType(data[index]));
  }, [areaId, data, dispatch]);

  const handleValue = (val) => {
    setValue(val);
    dispatch(setAreaType(val));
  };

  return (
    <div className="select-button-container">
      <SelectButton
        className="select-btn"
        value={value}
        onChange={(e) => handleValue(e.value)}
        options={data}
        disabled={isDisabled}
      />
    </div>
  );
};

export default SelectButtons;
